import React, { Suspense, useContext, useEffect } from 'react'
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify'
import { GlobalContext } from './context'
import { decryptedData } from './views/Access'
import loadGif from './assets/uedu_load_gif.gif'


const loading = (
  <div
    style={{
      width: '100vw',
      height: '100vh',
      justifyContent: 'center',
      alignItems: 'center',
    }}
    className="d-flex sk-double-bounce"
  >
    <div
      style={{
        marginTop: '-4%',
      }}
      className="d-flex flex-column"
    >
      <div className="d-flex justify-content-center">
        <img
          style={{ objectFit: 'contain', width: "30%" }}
          src={loadGif}
          alt='loadimage'
        />
      </div>
    </div>
  </div>
)

const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))
const Login = React.lazy(() => import('./views/pages/login/Login'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))

const AppRoutes = () => {
  const { state, dispatch } = useContext(GlobalContext)
  const [isLoading, setisLoading] = React.useState(true);
  const { isAuthenticated } = state

  const parseJwt = (token) => {
    try {
      return JSON.parse(atob(token.split('.')[1]))
    } catch (e) {
      return null
    }
  }

  const fetchData = async () => {
    const userData = await localStorage.getItem("USERDATA")
    const userToken = await localStorage.getItem("USERTOKEN")

    if (userData && userToken) {
      const decryptuserData = decryptedData(userData);
      const decryptuserToken = decryptedData(userToken);
      const decodedJwt = parseJwt(decryptuserToken)
      if (decodedJwt?.exp * 1000 < Date.now()) {
        dispatch({ type: "LOGOUT" })
        localStorage.clear()
        toast.error('Session has expired, please login again')
      } else {
        dispatch({
          type: "PROFILE",
          payload: { ...decryptuserData, userToken: decryptuserToken },
        })
      }
    } else {
      dispatch({ type: "LOGOUT" })
    }
    setisLoading(false)
  }

  useEffect(() => {
    fetchData()
  }, [])

  return (
    <>
      <ToastContainer />
      <Router>

        <Suspense fallback={loading}>
          {!isLoading &&
            <>
              {isAuthenticated ? (
                <Routes>
                  <Route path="/login" element={<Navigate to="/productManagement" replace />} />
                  <Route path="/*" element={<DefaultLayout />} />
                </Routes>
              ) : (
                <Routes>
                  <Route path="/" element={<Login />} />
                  <Route path="/login" element={<Login />} />
                  {/* Optional: uncomment and add Register component if used */}
                  {/* <Route path="/register" element={<Register />} /> */}
                  <Route path="/404" element={<Page404 />} />
                  <Route path="/500" element={<Page500 />} />
                  {/* Redirect unknown routes to login when unauthenticated */}
                  <Route path="/*" element={<Navigate to="/login" replace />} />
                  {/* <Route path="/*" element={<DefaultLayout />} /> */}
                </Routes>
              )}
            </>
          }
        </Suspense>
      </Router>
    </>
  )
}

export default AppRoutes
